var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('div',[_c('div',{staticClass:"loading"},[_c('div',[_c('i',{staticClass:"el-icon-loading"}),_c('span',[_vm._t("default")],2)])]),_c('div',{staticClass:"estop"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }